import React from 'react'
import AddPowerOfficialsBreadCrumb from './AddPowerOffcialsBreadCrumb' ;
import AddNewPowerOfficials  from './AddNewPowerOfficials';
function AddPowerOfficialsPage() {
    return ( 
        <div className='container-fluid'>
            <AddPowerOfficialsBreadCrumb />
            <AddNewPowerOfficials />
        </div>
     );
}

export default AddPowerOfficialsPage;